/**
 * planetDomain — is the current host the planet-city-game domain?
 *
 * gghere.com is the specialized domain for the planet worlds (spec
 * 2026-08-02). Both domains serve the same bundle from one Vercel project, so
 * the ONLY runtime difference is which component the root route renders. The
 * matching HTML shell is chosen at the edge by a host-conditional rewrite in
 * vercel.json — see the spec's "two cooperating layers" section.
 *
 * NOT the same predicate as `ownsViewer` in lib/community/feedClient.ts, which
 * answers "does this host serve /i/<id> locally?" and therefore also lists
 * jubit.ai and jubuddy.com. Do not merge them.
 */
import { IS_DESKTOP } from '../lib/desktopMode.ts';

const PLANET_HOST = 'gghere.com';

/** Escape hatch for localhost + preview deploys, which have no gghere hostname. */
const OVERRIDE_VALUE = 'gghere';

export function isPlanetDomain(hostname: string, search: string): boolean {
  if (new URLSearchParams(search).get('domain') === OVERRIDE_VALUE) return true;
  // Dot-anchored so 'notgghere.com' cannot match the apex.
  return hostname === PLANET_HOST || hostname.endsWith(`.${PLANET_HOST}`);
}

/** Browser-side convenience wrapper. Safe to call during render. */
export function isPlanetDomainNow(): boolean {
  // The Steam edition IS the planet and nothing else (ADR-0312): it serves
  // itself from 127.0.0.1, where no hostname rule could ever match, and a
  // desktop buyer must not land on the web's marketing home.
  if (IS_DESKTOP) return true;
  if (typeof window === 'undefined') return false;
  return isPlanetDomain(window.location.hostname, window.location.search);
}
